import { Dialog as Dialog$1 } from './Dialog.js';
import { DialogActions } from './DialogActions.js';
import { DialogTitle } from './DialogTitle.js';
import { DialogContent } from './DialogContent.js';
import { DialogHeader } from './DialogHeader.js';

var Dialog = Dialog$1;
Dialog.Actions = DialogActions;
Dialog.Title = DialogTitle;
Dialog.CustomContent = DialogContent;
Dialog.Content = DialogContent;
Dialog.Header = DialogHeader;
Dialog.Actions.displayName = 'Dialog.Actions';
Dialog.Title.displayName = 'Dialog.Title';
Dialog.Content.displayName = 'Dialog.Content';
Dialog.Header.displayName = 'Dialog.Header';

export { Dialog };
